module.exports = __webpack_public_path__ + "eot/OpenSans-CondBold-webfont.64868f.eot";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondBold-webfont.eot
 ** module id = 321
 ** module chunks = 12
 **/